// src/pages/TaxQuotePage/InvestmentPage.tsx

import React, { useContext, useEffect } from "react";
import { QuoteContext } from "../../context/QuoteContext";
import { useNavigate } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import { FaChartLine } from "react-icons/fa";
import styles from "./Quote.module.scss";

const InvestmentPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { investment, setInvestment } = useContext(QuoteContext)!;

  useEffect(() => {
    // const quoteSubmitted = sessionStorage.getItem("quoteSubmitted");
    // if (quoteSubmitted !== "true") {
    if (true) {
      navigate("/quote/investment");
    }
  }, [navigate]);

  const handleUnitChange = (
    categoryIndex: number,
    serviceIndex: number,
    value: string
  ) => {
    const unit = parseInt(value) || 0;
    const updatedInvestment = [...investment];
    const category = updatedInvestment[categoryIndex];
    const service = category.services[serviceIndex];

    service.unit = unit;
    service.total = unit * service.unitPrice;

    setInvestment(updatedInvestment);
  };

  const calculateTotal = () => {
    return investment.reduce((acc, category) => {
      return (
        acc + category.services.reduce((sum, service) => sum + service.total, 0)
      );
    }, 0);
  };

  const handleNext = () => {
    navigate("/quote/foreign_income_assets");
  };

  const handleBack = () => {
    navigate("/quote/basic");
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    if (e.target.value === "0") {
      e.target.value = "";
    }
  };

  const handleBlur = (
    e: React.FocusEvent<HTMLInputElement>,
    categoryIndex: number,
    serviceIndex: number
  ) => {
    if (e.target.value === "") {
      handleUnitChange(categoryIndex, serviceIndex, "0");
    }
  };

  return (
    <div className={styles.quoteContainer}>
      <div className={styles.quoteBox}>
        <h2 className={styles.sectionTitle}>
          <FaChartLine className={styles.titleIcon} />
          {t("taxQuote.investment.serviceName")}
        </h2>
        {investment.map((category, categoryIndex) => {
          // 如果为描述类分类
          if (category.isDescriptionOnly && category.descriptionKey) {
            return (
              <div className={styles.noteContainer} key={categoryIndex}>
                {t(category.descriptionKey)}
                {category.services.map((service) =>
                  service.noteKey ? (
                    <p key={service.id} className={styles.note}>
                      {t(service.noteKey)}
                    </p>
                  ) : null
                )}
              </div>
            );
          }

          return (
            <div key={category.id || categoryIndex} className={styles.category}>
              {category.nameKey && <h3>{t(category.nameKey)}</h3>}
              {category.services.length > 0 &&
              category.services.some((s) => s.unitPrice > 0) ? (
                <div className={styles.tableContainer}>
                  <table>
                    <thead>
                      <tr>
                        <th>{t("taxQuote.service")}</th>
                        <th>{t("taxQuote.unitPrice")}</th>
                        <th>{t("taxQuote.unit")}</th>
                        <th>{t("taxQuote.total")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {category.services.map((service, serviceIndex) =>
                        service.unitPrice > 0 ? (
                          <tr key={service.id}>
                            <td className={styles.serviceName}>
                              {t(service.nameKey)}
                              {service.noteKey && (
                                <span className={styles.small_note}>
                                  {t(service.noteKey)}
                                </span>
                              )}
                            </td>
                            <td>${service.unitPrice.toFixed(2)}</td>
                            <td>
                              <input
                                type="number"
                                min="0"
                                value={service.unit}
                                onChange={(e) =>
                                  handleUnitChange(
                                    categoryIndex,
                                    serviceIndex,
                                    e.target.value
                                  )
                                }
                                onFocus={handleFocus}
                                onBlur={(e) =>
                                  handleBlur(e, categoryIndex, serviceIndex)
                                }
                                onKeyPress={(e) => {
                                  if (!/[0-9]/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                className={styles.unitInput}
                              />
                            </td>
                            <td>${service.total.toFixed(2)}</td>
                          </tr>
                        ) : (
                          <tr key={service.id}>
                            <td colSpan={4}>{t(service.nameKey)}</td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              ) : (
                // 无有价项目则直接显示文本说明
                category.services.map((service) => (
                  <p key={service.id}>{t(service.nameKey)}</p>
                ))
              )}
            </div>
          );
        })}
        <h3 className={styles.sectionTotal}>
          {t("taxQuote.investment.investmentTotal")}: $
          {calculateTotal().toFixed(2)}
        </h3>
        <hr className={styles.divider} />
        {/* 新增的推荐文本：使用 Trans 组件多语言处理 */}
        <p className="referral-text">
          <Trans
            i18nKey="taxQuote.referralText"
            values={{ email: t("nav.email") }} // 使用键值对形式传入email值
            components={{
              strong: <strong />,
              a: <a href={`mailto:${t("nav.email")}`}>{t("nav.email")}</a>,
              br: <br />,
              em: <em />,
            }}
          />
        </p>
        <div className={styles.buttons}>
          <button onClick={handleBack}>{t("taxQuote.back")}</button>
          <button onClick={handleNext}>{t("taxQuote.next")}</button>
        </div>
      </div>
    </div>
  );
};

export default InvestmentPage;
